import React from 'react';
// import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
// import styled from 'styled-components';

type Props = {
	metadata: any;
	getProductDetails: Function;
	message?: any;
	shouldDisableActions;
};

const DisplayProduct = (props: Props) => {
	const { metadata, getProductDetails, message, shouldDisableActions } = props;
	let baseURL = process.env.REACT_APP_API;

	// const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
	// 	<Tooltip {...props} classes={{ popper: className }} />
	// ))(({ theme }) => ({
	// 	[`& .${tooltipClasses.tooltip}`]: {
	// 		fontSize: 14,
	// 		padding: 10,
	// 		lineHeight: 1.5,
	// 		letterSpacing: 0.32,
	// 	},
	// }));

	return (
		<>
			<div className='msg-server'>{message}</div>
			<div
				className={`ff-multichoice-container ${
					shouldDisableActions ? 'ff-disable-card' : ''
				} ${metadata && metadata.length > 0 ? '' : 'changedisplay'}`}
			>
				<div className='multichoice-cards-container'>
					{metadata &&
						metadata.length > 0 &&
						metadata.map((product: any, index: number) => {
							return (
								<div className='multichoice-products-container'>
									<div className='multichoice-each-product' key={index}>
										<img
											className='product-image'
											src={product.resourceURL}
											alt=''
										/>
										<div className='product-details'>
											{/* <LightTooltip title={product.title} placement='bottom'> */}
											<p className='product-name body1'>
												{index + 1}. {product.title}
											</p>
											{/* </LightTooltip> */}
											<p className='product-price body1'>
												<s className='non-discount-price caption'>
													{/* {product.currency} 585 */}
												</s>{' '}
												{product.currency} {product.price}
											</p>
										</div>
									</div>
									<button
										className='product-select-button'
										onClick={() => {
											getProductDetails(product.productId, product.title);
										}}
									>
										{/* <LightTooltip title={product.title} placement='bottom'> */}
										<p className='button-text'>{product.title}</p>
										{/* </LightTooltip> */}
									</button>
								</div>
							);
						})}
				</div>
			</div>
		</>
	);
};

export default DisplayProduct;
